import EmblaCarousel from 'embla-carousel';

( () => {
  // Navigation toggle
  const header_toggle = document.querySelector( '.header__button' );
  const header_block = document.querySelector( '.header' );

  if ( !header_toggle || !header_block ) {
    return;
  }

  header_toggle.addEventListener( 'click', () => {
    header_toggle.classList.toggle( 'toggled', !header_toggle.classList.contains( 'toggled' ) );
    header_block.classList.toggle( 'toggled', !header_block.classList.contains( 'toggled' ) );
  } );
} )();

( () => {
  const shareButton = document.querySelector( '.share-button' );

  if (!shareButton) {
    return;
  }

  // Share must be triggered by 'user activation'
  shareButton.addEventListener('click', event => {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: document.location.href
      })
      .catch(console.error);
    } else {
      navigator.clipboard.writeText(document.location.href);
      shareButton.querySelector('span').innerHTML = "Link copied!";
    }
  });
} )();

( () => {
  const all_tab_buttons = document.querySelectorAll( '.tab__link' );
  const all_tab_content = document.querySelectorAll( '.tab__content' );

  function openTab( tab_button, tab_id ) {
    // Remove active status from all tab content
    for ( let i = 0; i < all_tab_content.length; i++ ) {
      all_tab_content[i].classList.remove( 'tab__content--active' );
    }

    // Remove active status from all tab buttons
    for ( let i = 0; i < all_tab_buttons.length; i++ ) {
      all_tab_buttons[i].className = all_tab_buttons[i].className.replace( 'tab__link--active', '' );
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById( tab_id ).classList.add( 'tab__content--active' );
    tab_button.classList.add( 'tab__link--active' );
  }

  for ( let i = 0; i < all_tab_buttons.length; i += 1 ) {
    all_tab_buttons[i].addEventListener( 'click', ( e ) => {
      openTab( e.target, all_tab_buttons[i].getAttribute( 'data-tab-id' ) );
    } );
  }

  if ( all_tab_buttons.length > 0 || all_tab_content.length > 0 ) {
    // Activate the first tab on page load
    all_tab_buttons[0].classList.add( 'tab__link--active' );
    all_tab_content[0].classList.add( 'tab__content--active' );
  }
} )();

( () => {
  // Toggle filters
	window.addEventListener( 'click', ( event ) => {
		if ( event.target.classList.contains( 'filter__toggle' ) ) {
			event.target.parentElement.classList.toggle( 'filter--expanded' );
		}
	} );
} )();

( () => {
	// Initialise slider elements
	const slider_elements = [].slice.call( document.querySelectorAll( '.content-slider' ) );
	slider_elements.map( slider_element =>
		createSlider( slider_element )
	);
} )();

function createSlider( slider_element ) {
	// Content slider
	const slider_pips = slider_element.querySelectorAll( '.content-slider__pip' );
	const slider_next = slider_element.querySelector( '.content-slider__button--next' );
	const slider_prev = slider_element.querySelector( '.content-slider__button--prev' );

	const slider__opts = {
		align: 'start',
		containerSelector: '.content-slider__inner',
		loop: false,
		speed: 10,
		selectedClass: 'content-slider--selected',
	};

	const slider = EmblaCarousel( slider_element, slider__opts );

	slider_pips.forEach( ( pip, index ) => {
		pip.addEventListener( 'click', () => {
			slider.scrollTo( index );
		}, false );
	} );

	slider_next.addEventListener( 'click', () => {
		slider.scrollNext();
	}, false );

	slider_prev.addEventListener( 'click', () => {
		slider.scrollPrev();
	}, false );

	slider.on( 'select', () => {
		const index = slider.selectedScrollSnap();
		clearPips();
		resetButtonState( slider_prev, slider.canScrollPrev() );
		resetButtonState( slider_next, slider.canScrollNext() );
		slider_pips[index].classList.add( 'content-slider__pip--active' );
	} );

	function clearPips() {
		slider_pips.forEach( ( pip ) => {
			pip.classList.remove( 'content-slider__pip--active' );
		} );
	}

	function resetButtonState( element, state ) {
		if ( state ) {
			element.classList.add( 'content-slider__button--can' );
		} else {
			element.classList.remove( 'content-slider__button--can' );
		}
	}
}
